import React, { useState } from 'react';

const HOURS = ['09:00','09:30','10:00','10:30','11:00','11:30','12:00','12:30','13:00','13:30','14:00','14:30','15:00','15:30','16:00','16:30','17:00'];

const BOOKED = [
  { id:1, title:'Discovery call — Arsenal FC',   contact:'James Morris',   date:'Apr 7, 2026',  time:'10:00', duration:'30 min', status:'Confirmed' },
  { id:2, title:'Onboarding walkthrough — PSG',  contact:'Pierre Dubois',  date:'Apr 8, 2026',  time:'14:00', duration:'45 min', status:'Confirmed' },
  { id:3, title:'Follow-up — Juventus',          contact:'Luca Bianchi',   date:'Apr 10, 2026', time:'11:30', duration:'30 min', status:'Pending'   },
  { id:4, title:'Scout check-in — Alex Aldridge',contact:'Alex Aldridge',  date:'Apr 11, 2026', time:'09:00', duration:'20 min', status:'Confirmed' },
];

const DAYS = ['Mon Apr 7','Tue Apr 8','Wed Apr 9','Thu Apr 10','Fri Apr 11'];
const BOOKED_SLOTS = { 'Mon Apr 7':['10:00'], 'Tue Apr 8':['14:00'], 'Thu Apr 10':['11:30'], 'Fri Apr 11':['09:00'] };

const statusBadge = s => s === 'Confirmed' ? 'badge badge-green' : 'badge badge-amber';

export default function Meetings({ toast }) {
  const [tab, setTab]             = useState('calendar');
  const [selectedDay, setDay]     = useState('Mon Apr 7');
  const [selectedTime, setTime]   = useState(null);
  const [booking, setBooking]     = useState(false);
  const [meetings, setMeetings]   = useState(BOOKED);
  const [form, setForm]           = useState({ title:'', contact:'', duration:'30 min', notes:'' });
  const [linkCopied, setLinkCopied] = useState(false);

  const bookedForDay = BOOKED_SLOTS[selectedDay] || [];

  const bookSlot = () => {
    if (!form.title || !form.contact) { toast?.('Fill in title and contact', 'warning'); return; }
    const m = { id:Date.now(), title:form.title, contact:form.contact, date:selectedDay, time:selectedTime, duration:form.duration, status:'Confirmed' };
    setMeetings(prev => [...prev, m]);
    setBooking(false); setSelectedTime(null);
    setForm({ title:'', contact:'', duration:'30 min', notes:'' });
    toast?.('Meeting booked ✓');
  };

  const copyLink = () => {
    navigator.clipboard?.writeText('https://meetings.transferexpo.com/habeeb');
    setLinkCopied(true);
    setTimeout(() => setLinkCopied(false), 2000);
    toast?.('Booking link copied!');
  };

  return (
    <div>
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">This week</div><div className="stat-value">{meetings.filter(m=>m.status==='Confirmed').length}</div><div className="stat-sub stat-up">Confirmed meetings</div></div>
        <div className="stat-card"><div className="stat-label">Pending</div><div className="stat-value">{meetings.filter(m=>m.status==='Pending').length}</div><div className="stat-sub">Awaiting confirmation</div></div>
        <div className="stat-card"><div className="stat-label">Total this month</div><div className="stat-value">12</div><div className="stat-sub">All meetings</div></div>
        <div className="stat-card">
          <div className="stat-label">Booking link</div>
          <div style={{ marginTop:6 }}>
            <button className="btn btn-primary" style={{ fontSize:11, padding:'4px 12px' }} onClick={copyLink}>
              {linkCopied ? '✓ Copied!' : 'Copy link'}
            </button>
          </div>
          <div style={{ fontSize:10, color:'var(--text-dim)', marginTop:4 }}>meetings.transferexpo.com/habeeb</div>
        </div>
      </div>

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
        <div className="filter-pills" style={{ marginBottom:0 }}>
          {['calendar','list'].map(t => (
            <button key={t} className={`pill ${tab===t?'active':''}`} onClick={() => setTab(t)} style={{ textTransform:'capitalize' }}>{t==='calendar'?'Calendar view':'List view'}</button>
          ))}
        </div>
        <button className="btn btn-primary" onClick={() => { setBooking(true); setTab('calendar'); }}>+ Schedule meeting</button>
      </div>

      {tab === 'calendar' && (
        <div style={{ display:'grid', gridTemplateColumns:'1fr 320px', gap:16 }}>
          {/* Calendar grid */}
          <div className="card" style={{ padding:0 }}>
            <div style={{ display:'grid', gridTemplateColumns:`repeat(${DAYS.length}, 1fr)`, borderBottom:'1px solid var(--border)' }}>
              {DAYS.map(d => (
                <div key={d} onClick={() => setDay(d)} style={{ padding:'12px 8px', textAlign:'center', cursor:'pointer', borderRight:'1px solid var(--border)', background: selectedDay===d ? 'rgba(167,244,50,0.08)' : 'transparent', borderBottom: selectedDay===d ? '2px solid var(--accent)' : '2px solid transparent' }}>
                  <div style={{ fontSize:11, color:'var(--text-dim)', marginBottom:2 }}>{d.split(' ')[0]}</div>
                  <div style={{ fontSize:13, fontWeight:600, color: selectedDay===d ? 'var(--accent)' : 'var(--text-primary)' }}>{d.split(' ').slice(1).join(' ')}</div>
                </div>
              ))}
            </div>
            <div style={{ padding:16, maxHeight:420, overflowY:'auto' }}>
              {HOURS.map(h => {
                const isBooked = bookedForDay.includes(h);
                const isSelected = selectedTime === h;
                return (
                  <div key={h} onClick={() => !isBooked && setTime(isSelected ? null : h)}
                    style={{ display:'flex', alignItems:'center', gap:12, padding:'10px 12px', marginBottom:4, borderRadius:8, cursor: isBooked ? 'not-allowed' : 'pointer',
                      background: isBooked ? 'rgba(167,244,50,0.05)' : isSelected ? 'rgba(167,244,50,0.12)' : 'var(--bg-input)',
                      border: `1px solid ${isSelected ? 'var(--accent)' : 'var(--border)'}`,
                      opacity: isBooked ? 0.6 : 1 }}>
                    <span style={{ fontSize:12, color:'var(--text-dim)', minWidth:40, fontFamily:'var(--font-ui)' }}>{h}</span>
                    {isBooked
                      ? <span style={{ fontSize:12, color:'var(--accent)', fontWeight:500 }}>● Booked</span>
                      : isSelected
                      ? <span style={{ fontSize:12, color:'var(--accent)', fontWeight:500 }}>Selected — click to confirm below</span>
                      : <span style={{ fontSize:12, color:'var(--text-dim)' }}>Available</span>}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Booking form */}
          <div>
            {(selectedTime || booking) ? (
              <div className="card">
                <div className="card-header"><span className="card-title">Book meeting</span></div>
                {selectedTime && <div style={{ fontSize:13, color:'var(--accent)', fontWeight:500, marginBottom:14 }}>{selectedDay} at {selectedTime}</div>}
                <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
                  <div><label style={{ fontSize:11, color:'var(--text-muted)', display:'block', marginBottom:5 }}>Meeting title *</label>
                    <input className="search-input" placeholder="e.g. Discovery call" value={form.title} onChange={e => setForm(f=>({...f,title:e.target.value}))} /></div>
                  <div><label style={{ fontSize:11, color:'var(--text-muted)', display:'block', marginBottom:5 }}>Contact *</label>
                    <input className="search-input" placeholder="Contact name" value={form.contact} onChange={e => setForm(f=>({...f,contact:e.target.value}))} /></div>
                  <div><label style={{ fontSize:11, color:'var(--text-muted)', display:'block', marginBottom:5 }}>Duration</label>
                    <select className="search-input" value={form.duration} onChange={e => setForm(f=>({...f,duration:e.target.value}))}>
                      {['15 min','20 min','30 min','45 min','60 min'].map(d=><option key={d}>{d}</option>)}
                    </select></div>
                  <div><label style={{ fontSize:11, color:'var(--text-muted)', display:'block', marginBottom:5 }}>Notes</label>
                    <textarea className="search-input" rows={3} placeholder="Agenda / notes..." value={form.notes} onChange={e => setForm(f=>({...f,notes:e.target.value}))} style={{ resize:'none', fontFamily:'var(--font-body)' }} /></div>
                  <div style={{ display:'flex', gap:8 }}>
                    <button className="btn btn-primary" onClick={bookSlot} disabled={!selectedTime}>Book meeting</button>
                    <button className="btn btn-ghost" onClick={() => { setBooking(false); setTime(null); }}>Cancel</button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="card" style={{ textAlign:'center', padding:'40px 20px' }}>
                <div style={{ fontSize:32, marginBottom:12 }}>📅</div>
                <div style={{ fontSize:14, color:'var(--text-muted)', marginBottom:8 }}>Select a time slot</div>
                <div style={{ fontSize:12, color:'var(--text-dim)' }}>Click any available slot to book a meeting</div>
              </div>
            )}
          </div>
        </div>
      )}

      {tab === 'list' && (
        <div className="card" style={{ padding:0 }}>
          <div className="card-header" style={{ padding:'16px 20px', borderBottom:'1px solid var(--border)' }}>
            <span className="card-title">All meetings</span>
          </div>
          <div className="table-wrap">
            <table>
              <thead><tr><th>Meeting</th><th>Contact</th><th>Date</th><th>Time</th><th>Duration</th><th>Status</th><th>Action</th></tr></thead>
              <tbody>
                {meetings.map(m => (
                  <tr key={m.id}>
                    <td style={{ fontWeight:500 }}>{m.title}</td>
                    <td style={{ color:'var(--text-muted)' }}>{m.contact}</td>
                    <td style={{ color:'var(--text-muted)', fontSize:12 }}>{m.date}</td>
                    <td style={{ color:'var(--accent)', fontWeight:600 }}>{m.time}</td>
                    <td style={{ color:'var(--text-dim)', fontSize:12 }}>{m.duration}</td>
                    <td><span className={statusBadge(m.status)}>{m.status}</span></td>
                    <td><button className="btn btn-ghost" style={{ fontSize:11, padding:'4px 10px' }} onClick={() => { setMeetings(prev => prev.filter(x=>x.id!==m.id)); toast?.('Meeting cancelled'); }}>Cancel</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
